module.exports = __webpack_public_path__ + "static/media/coding1.ce42c5fa.png";